import type { SVGProps } from 'react';
const SvgMap = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" {...props}>
    <path d="M565.6 36.2C572.1 40.7 576 48.1 576 56v336c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1.3l-183.9-61.2-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3l183.9 61.2 160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5v284.7l120-45.7V90.8zm312 286.2V137.3l-144-48v285.4zm48-1.5 120-45.7V90.8l-120 45.7z" />
  </svg>
);
export default SvgMap;
